import Colors from "enums/Colors";
import styled from "styled-components";



const FormFVStyle = {

     FormFerramentaVideo: styled.form<{ active: boolean }>`
        background: rgba(255, 255, 255, 0.07);
        border-radius: 12px;
        padding: 32px 24px;
        width: 820px;
        box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.1);
        display: grid;
        grid-template-columns: 1fr;
        gap: 24px;
        position: absolute;
        transition-duration: 1s;
        border: 1px solid ${Colors.Blue};
        transform: ${props => (props.active ? 'translateX(0)' : 'translateX(-1280px)')};
        background-color: #f5f5f5;
        top: 120px;
        z-index: 10;
    `,

     FormPackage: styled.form<{ active: boolean }>`
        background: rgba(255, 255, 255, 0.07);
        border-radius: 12px;
        padding: 32px 24px;
        width: 1000px;
        box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.1);
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 24px;
        position: absolute;
        transition-duration: 1s;
        border: 1px solid ${Colors.Blue};
        transform: ${props => (props.active ? 'translateX(0)' : 'translateX(-1440px)')};
        background-color: #f5f5f5;
        top: 120px;
        z-index: 10;
    `,


}

export default FormFVStyle;